export default "__VITE_ASSET__CZKjavnz__"